import { getDefaultConfig } from '@rainbow-me/rainbowkit';
import { polygon } from 'wagmi/chains';
import { http } from 'wagmi';

const projectId = import.meta.env.VITE_WALLETCONNECT_PROJECT_ID;
const rpcUrl = import.meta.env.VITE_POLYGON_RPC || 'https://polygon-rpc.com';

if (!projectId) {
  console.warn(
    '[wagmi] VITE_WALLETCONNECT_PROJECT_ID is not set. WalletConnect (mobile wallets) will not work.',
  );
}

export const wagmiConfig = getDefaultConfig({
  appName: 'AltCoinsMoney',
  projectId: projectId || 'fallback',
  chains: [polygon],
  transports: {
    [polygon.id]: http(rpcUrl),
  },
  ssr: false,
});

export const POLYGON_CHAIN_ID = polygon.id;
